import { UIText1, useDeviceType } from '@cian/ui-kit';
import React, { PropsWithChildren } from 'react';
import cn from 'classnames';

import { Section } from '../Section';

import * as styles from './styles.css';

export const CallToActionCardLayout: React.FC<PropsWithChildren> = props => {
  const deviceType = useDeviceType();

  return (
    <Section testId="callToActionSection">
      <h2 className={cn(styles['h2'], styles[deviceType])}>Зачем нужен риелтор</h2>
      <div className={styles['description']}>
        <UIText1>
          Циан.Сделку можно провести только с риелтором. Риелтор поможет собрать документы, составит договор
          купли-продажи, будет всегда на связи с нашим персональным помощником и ответит на любые вопросы.
        </UIText1>
      </div>
      <div className={cn(styles['grid'], styles[deviceType])}>{props.children}</div>
    </Section>
  );
};
